import { SceneLightState } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionLight',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionLight extends SceneActionGeneral {
  SceneLightState = SceneLightState;

  get isConfirmEnabled() {
    return true;
  }
}
